import React, { useEffect, useRef} from 'react';
import styles from "./menus.module.scss";
import Group from "../../styles/images/worktuallogo.svg";
import { useHistory } from "react-router-dom";
import { contactService } from "../../base/contactService";
import { useSelector } from "react-redux";
import _ from 'lodash';
import store from "../../context/store/store";
import { recentChatSocketReducerStateModel, initialStateModel, contacts, UserDetails } from "../../models/model";
import { ChatService } from '../../base/chatService';
import { storeWindowState } from '../../base/meetingService/meetingStoreServices';
import { chatSideWindow } from '../../base/eventService/eventApiService';
import { Types } from '../../context/action/action';
//import { updateMeetingTotalBatch } from '../../base/meetingService/apiService';
import { config } from '../../base/constant';
import { Dropdown, Tooltip } from 'antd';
import appSwitch from "../../styles/images/appSwitch.svg";
import globalMyAcnt from "../../styles/images/My_account.svg";
import contact from "../../styles/images/CCaas.svg";
import crm from "../../styles/images/CRM.svg";
import {handleStartRecording, handleStopRecording, resetValue, setAiAssist } from '../../base/callService/common';
import { v4 as uuidv4 } from 'uuid';


export default function MainMenus() {
  let { meetingTotalCount } = store.getState().meetingReducer || [];
  const {recentChatList}: recentChatSocketReducerStateModel = 
  useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const { loginReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
  const recentArray = Object.values(recentChatList);
  let contactReducer: contacts = store.getState().contactReducer || [];
  const {intent}:any=store.getState().chatReducer;
  const history = useHistory();
  useEffect(()=>{
    contactService.clearRecentchat();
    ChatService.editDraft(false);
  },[]);
  const openChat =()=>{
    openNavigation();
    history.push('/chats');
    ChatService.saveChatHighlight(false,{});
    ChatService.filesHighlight(false,{});
    chatSideWindow(false, "", {});
    store.dispatch({
      type: Types.CHAT_SEARCH_STORE,
      payload: {
        searchData: "",
        isSearch: false
      }
    });
    resetValue();
  };

  const openNavigation = () =>{ 
    ChatService.updateNavigation(true);
    setTimeout(()=>{
      ChatService.updateNavigation(false);
    },3000)
    ChatService.openContactWindow({})
    resetValue();
  }

  const openContact =()=>{
    history.push('/contacts');
    contactService.clearforContact();
    openNavigation();
    resetValue();
  };

   const openMeeting =()=>{
     history.push('/meeting');
     storeWindowState("mainPage");
     resetValue();
     
  };


  useEffect(()=>{
    if(intent &&( intent === "send_a_Message" || intent === "send_message") && window.location.pathname!=="/chats"){
      history.push("/chats");
    }
  },[intent])

 
  // let unreadCount:any = _.sumBy(recentArray, function(value:any) { 
  //   if(value?.unreadCount>0 && value?.settings?.isDeleted?.["s"+loginReducer?.userdetails?.sip_login_id]===0 && value?.settings?.isArchive &&
  //    value?.settings?.isArchive["s"+loginReducer?.userdetails?.sip_login_id]===0 ){
  //     return value?.unreadCount || 0;
  //   }
  // }); 
  let unreadCount:any = _.filter(recentArray, function(value:any) { 
    if(value?.unreadCount>0 && value?.settings?.isDeleted?.["s"+loginReducer?.userdetails?.sip_login_id]===0 && value?.settings?.isArchive &&
     value?.settings?.isArchive["s"+loginReducer?.userdetails?.sip_login_id]===0 ){
     let textValue = value?.type === 2 ? contactReducer?.teamContacsnew['con'+value?.chatId] : contactReducer?.workContactsnew[value?.to]
     if(textValue !== undefined){
        return value?.unreadCount || 0;
      }
    }
  }); 

  document.title= unreadCount?.length > 0 ?"Worktual Web Application ("+ unreadCount?.length +")" : "Worktual Web Application";

  const openMyAcnt = () => {
    window.open(`${config().MyAccountURL}`, "_blank");
    resetValue();
  }

  const openCcassAct=()=>{
    window.open(`${config().CCAASS_URL}`, "_blank");
  }
  const openAISuggestion=()=>{
    const{isAiAssist,isCaptureAi}:any=store.getState().chatReducer;
    setAiAssist(!isAiAssist,!isCaptureAi,"Listening...",{suggestions:[],prompt:"",error:""})
    if(!isAiAssist) {
      let aiSession:any= uuidv4();
      store.dispatch({
        type:Types.SET_ARR_BUFFER,
        payload:{
          aiSessionId:aiSession,
          arrayBuffer:[],
          intent:"",
          aiAssistMessage:""
        }
      })
      handleStartRecording();
    }else{
      store.dispatch({
        type:Types.SET_ARR_BUFFER,
        payload:{
          aiSessionId:"",
          arrayBuffer:[],
          intent:"",
          aiAssistMessage:""
        }
      })
      handleStopRecording();}
      resetValue();
  }
  const userinfo: any = sessionStorage.getItem("userinfo");
  const parsedInfo =JSON.parse(userinfo);


  const menu = (
    <div className='accessBar'>
    <div className='bottomcontsec'>
      <div className='logoleftcosec'>
      <div  className='listiconclr' >
         <img src={globalMyAcnt} alt="" />
          <h3>Global
            My Account</h3>
        </div>
        {parsedInfo?.purchasedAccess?.map((list: any, index: any) => {
          return (
            <div key={index} className='listiconclr' >

              {list.productName === "Contact Center Platform" && <><img src={contact} alt="" />
                <h3>Contact Center
                  Platform</h3>
              </>}
              {list.productName === "CRM" && <> <img src={crm} alt="" />
                <h3>CRM</h3>
              </>}

            </div>
          );

        })}

      </div>
    </div>
  </div>
  );
  return (
    <>
      <div className={styles.menusmain}>
        <img src={Group} alt=""/>
        <ul>
          {/* <li className={history.location.pathname === '/chats' ?`${styles.active}`:
              ""}>
            <span className={history.location.pathname === '/chats' ?`icon__MessageWhite ${styles.active}`:
              "icon__MessageGrey"} onClick={()=>history.push('/chats')}></span>
            {unreadCount?.length>0 && <span className={`zoomIn ${styles.totalCount}`}>{unreadCount?.length>99?"99+":unreadCount?.length}</span>} 
          </li>
          <li className={history.location.pathname === '/calls' ?`${styles.active}`:
              ""}><span className={history.location.pathname === '/calls' ? `icon__CallWhite ${styles.active}`
            :"icon__CallGrey"} onClick={()=>history.push('/calls')}></span></li>
          <li className={history.location.pathname === '/contacts' ?`${styles.active}`:
              ""}><span className={history.location.pathname === '/contacts'?`icon__ContactWhite ${styles.active}`:
            "icon__ContactGrey"} onClick={openContact}></span></li>
          <li className={history.location.pathname === '/meeting' ?`${styles.active}`:
              ""}><span className={history.location.pathname === '/meeting'?`icon__MeetWhite ${styles.active}`:
            "icon__MeetGrey"} onClick={()=>history.push('/meeting')}></span>
             {meetingTotalCount.count>0 && <span className={`zoomIn ${styles.totalCount}`}>{meetingTotalCount.count>99?"99+":meetingTotalCount.count}</span>} 
            </li> */}
            <li onClick={()=>{openChat()}} className={history.location.pathname === '/chats' ?`${styles.active}`:
              ""}>
            <span className={history.location.pathname === '/chats' ?`icon__MessageGrey ${styles.active}`:
              "icon__MessageWhite"}></span>
               {unreadCount?.length>0 && <span className={`zoomIn ${styles.totalCount}`}>{unreadCount>99?"99+":unreadCount?.length}</span>} 
          </li>
          <li  onClick={()=>{history.push('/calls');openNavigation()}} className={history.location.pathname === '/calls' ?`${styles.active}`:
              ""}><span className={history.location.pathname === '/calls' ? `icon__CallGrey ${styles.active}`
            :"icon__CallWhite"}></span></li>
          <li className={history.location.pathname === '/contacts' ?`${styles.active}`:
              ""}><span className={history.location.pathname === '/contacts'?`icon__ContactGrey ${styles.active}`:
            "icon__ContactWhite"} onClick={()=>{openContact()}}></span></li>


          <li  className={history.location.pathname === '/meeting' ?`${styles.active}`:
              ""}><span className={history.location.pathname === '/meeting'?`icon__MeetGrey ${styles.active}`:
            "icon__MeetWhite"} onClick={openMeeting}></span>
             {meetingTotalCount.count>0 && <span className={`zoomIn ${styles.totalCount}`}>{meetingTotalCount.count>99?"99+":meetingTotalCount.count}</span>}
             </li>
           {(parsedInfo?.purchasedAccess?.length > 1) &&
            // <Dropdown overlay={menu} trigger={["click"]}>
              <Tooltip placement="right" title="Worktual Switches">
                <li onClick={openCcassAct}>
                  <img src={appSwitch} alt="" />
                </li>
              </Tooltip>
            //  </Dropdown> 
            }

            {
                   <li className={styles.blinkingdivicon} id="aiicon" onClick={openAISuggestion}>
          <svg xmlns="http://www.w3.org/2000/svg" id="aisvg" width="56" height="62" viewBox="0 0 56 62" fill="none">
<path id="aiicon" d="M27.8093 50.4898C38.1975 50.4898 46.6187 42.0686 46.6187 31.6804C46.6187 21.2923 38.1975 12.8711 27.8093 12.8711C17.4212 12.8711 9 21.2923 9 31.6804C9 42.0686 17.4212 50.4898 27.8093 50.4898Z" fill="#00E2A4"/>
<path id="aiicon" d="M28.2354 23.8711C27.6958 23.8711 27.2582 24.3085 27.2582 24.8483V38.9785C27.2582 39.5181 27.6958 39.9558 28.2354 39.9558C28.7751 39.9558 29.2127 39.5181 29.2127 38.9785V24.8483C29.2127 24.3085 28.7751 23.8711 28.2354 23.8711Z" fill="black"/>
<path id="aiicon" d="M37.4937 29.1374C36.954 29.1374 36.5164 29.5748 36.5164 30.1146V33.7121C36.5164 34.2517 36.954 34.6894 37.4937 34.6894C38.0334 34.6894 38.4709 34.2517 38.4709 33.7121V30.1146C38.4709 29.5748 38.0334 29.1374 37.4937 29.1374Z" fill="black"/>
<path id="aiicon" d="M18.9772 29.1374C18.4375 29.1374 18 29.5748 18 30.1146V33.7121C18 34.2517 18.4375 34.6894 18.9772 34.6894C19.5169 34.6894 19.9545 34.2517 19.9545 33.7121V30.1146C19.9545 29.5748 19.5169 29.1374 18.9772 29.1374Z" fill="black"/>
<path id="aiicon" d="M32.8646 26.9132C32.3249 26.9132 31.8873 27.3506 31.8873 27.8904V35.9367C31.8873 36.4763 32.3249 36.914 32.8646 36.914C33.4042 36.914 33.8418 36.4763 33.8418 35.9367V27.8904C33.8418 27.3506 33.4042 26.9132 32.8646 26.9132Z" fill="black"/>
<path id="aiicon" d="M23.6063 26.9132C23.0666 26.9132 22.6291 27.3506 22.6291 27.8904V35.9367C22.6291 36.4763 23.0666 36.914 23.6063 36.914C24.146 36.914 24.5836 36.4763 24.5836 35.9367V27.8904C24.5836 27.3506 24.146 26.9132 23.6063 26.9132Z" fill="black"/>
</svg>
          </li>
          
            }
            {/* { (parsedInfo?.ext=== "200"&&parsedInfo?.purchasedAccess?.length===1)&& */}
             <Tooltip placement="right" title="My Account">
             <li onClick={openMyAcnt}>
             <img src={globalMyAcnt} className="leftbtmicon" alt=""/>
             </li>
             </Tooltip>
            {/* //  } */}

             
        </ul>
      </div>
    </>
  );
};

